"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_react_1 = require("mobx-react");
var owa_analytics_1 = require("owa-analytics");
var React = require("react");
var styles = require('./MessageAdReadingPane.scss');
var msNativeAdsScriptLocUrl = '//h6.msn.com/nativeads/ms-nativeads-outlook.min.js';
// const {
//     name: clickNativeAdEventName,
//     customData: clickNativeAdCustomData,
// } = datapoints.ClickNativeAd.datapoint;
var mouseOverIFrame;
var MessageBody = /** @class */ (function (_super) {
    tslib_1.__extends(MessageBody, _super);
    function MessageBody() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClickImageHandler = function (ev) {
            _this.OpenTargetClickWebSite('image');
        };
        _this.onClickTextsAboveImageHandler = function (ev) {
            _this.OpenTargetClickWebSite('textsAboveImage');
        };
        _this.onClickTextsBelowImageHandler = function (ev) {
            _this.OpenTargetClickWebSite('textsBelowImage');
        };
        _this.onClickTextsOnImageHandler = function (ev) {
            _this.OpenTargetClickWebSite('textsOnImage');
        };
        // This is a typical way to detect the click event in a cross-domain iFrame as the cross-domain iFrame itself could not send anything back to the main window
        // When the click happens in the iFrame, the main window will be "blurred" to lose the focus
        _this.onMouseOverIframe = function () {
            mouseOverIFrame = true;
        };
        _this.onMouseOutIframe = function () {
            mouseOverIFrame = false;
        };
        _this.onIFrameClicked = function () {
            if (mouseOverIFrame) {
                _this.LogClickNativeAdDataPoint('iFrame');
            }
        };
        return _this;
    }
    MessageBody.prototype.componentDidMount = function () {
        // When adTextsToRenderBody is not null, we will render the Bing Ad iFrame and listen to the blur event so that we can log the iFrame click situation
        this.props.adTextsToRenderBody && this.showBingAdiFrame();
        window.addEventListener('blur', this.onIFrameClicked);
    };
    MessageBody.prototype.componentWillUnmount = function () {
        window.removeEventListener('blur', this.onIFrameClicked);
    };
    MessageBody.prototype.OpenTargetClickWebSite = function (clickArea) {
        this.LogClickNativeAdDataPoint(clickArea);
        window.open(this.props.adImageTargetUrl, '_blank');
    };
    MessageBody.prototype.LogClickNativeAdDataPoint = function (clickArea) {
        owa_analytics_1.logUsage('ClickNativeAd', {
            messageAdType: this.props.adType,
            userMarket: this.props.adMarket,
            refreshEvent: this.props.adRefreshEvent,
            clickArea: clickArea,
        });
    };
    MessageBody.prototype.renderAdTextsOutsideImage = function (adTextsOutsideImage, adTextsOutsideImageStyleName, isTextsAboveImage) {
        return adTextsOutsideImage == null ? null : (React.createElement("div", { className: styles.adDescriptionTextsOnMessageBodyContainer }, React.createElement("span", { className: adTextsOutsideImageStyleName, onClick: isTextsAboveImage
                ? this.onClickTextsAboveImageHandler
                : this.onClickTextsBelowImageHandler }, adTextsOutsideImage)));
    };
    MessageBody.prototype.renderImage = function (imageUrl, textsOnImageLine1, textsOnImageLine2) {
        var textsOnImageDiv = textsOnImageLine1 == null ? null : (React.createElement("div", { className: styles.div3, onClick: this.onClickTextsOnImageHandler },
            React.createElement("div", { className: styles.span1 },
                React.createElement("span", null, textsOnImageLine1)),
            React.createElement("div", { className: styles.span2 },
                React.createElement("span", null, textsOnImageLine2))));
        return (React.createElement("div", { className: styles.div1 },
            React.createElement("div", { className: styles.div2, onClick: this.onClickImageHandler },
                React.createElement("img", { className: styles.img1, src: imageUrl }),
                textsOnImageDiv)));
    };
    MessageBody.prototype.render = function () {
        var _this = this;
        // Add a clear:both div after messageBody to avoid table with float:left overflowing parent div
        return (React.createElement("div", null,
            this.renderAdTextsOutsideImage(this.props.adTextsAboveImage, styles.adTextsAboveImage, true),
            React.createElement("iframe", { className: styles.adBodyIFrame, onMouseOver: this.onMouseOverIframe, onMouseOut: this.onMouseOutIframe, ref: function (i) {
                    _this.iframeElement = i;
                } }),
            this.renderImage(this.props.adImageUrl, this.props.adTextsOnImage, this.props.adCallToActionTextsOnImage),
            this.renderAdTextsOutsideImage(this.props.adCallToActionTextsBelowImage, styles.adTextsBelowImage, false),
            React.createElement("div", null),
            React.createElement("div", { className: styles.clearBoth })));
    };
    MessageBody.prototype.showBingAdiFrame = function () {
        var _this = this;
        this.iframeElement.onload = function () {
            _this.iframeElement.onload = null;
            _this.iframeElement.setAttribute('scrolling', 'no');
            var iframeDocument = _this.iframeElement.contentDocument;
            if (!iframeDocument.body) {
                iframeDocument.write('<body><div id="owaBingNativeAd"></div></body>');
            }
            var divContainer = _this.iframeElement.contentWindow.document.createElement('div');
            divContainer.id = 'owaBingNativeAd';
            _this.iframeElement.contentWindow.document.body.appendChild(divContainer);
            var nativeAdsContext = {
                msNativeAdsScriptLoc: msNativeAdsScriptLocUrl,
                adResponseText: _this.props.adTextsToRenderBody,
                publisherName: 'Outlook',
            };
            _this.iframeElement.contentWindow.nativeAdsContext = nativeAdsContext;
            var scriptElement = _this.iframeElement.contentWindow.document.createElement('script');
            scriptElement.src = 'https://' + msNativeAdsScriptLocUrl;
            scriptElement.type = 'text/javascript';
            _this.iframeElement.contentWindow.document.body.appendChild(scriptElement);
        };
        this.iframeElement.src = 'about:blank';
    };
    MessageBody = tslib_1.__decorate([
        mobx_react_1.observer
    ], MessageBody);
    return MessageBody;
}(React.Component));
exports.default = MessageBody;
//# sourceMappingURL=MessageBody.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-messagead-readingpane-view/lib/components/MessageBody.js
// module id = 5560
// module chunks = 17